import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
// stores
import { CartStore } from 'src/app/core/stores/cart.store';
// rxjs
import { Subject } from 'rxjs';
// models
import { MenuItemForPayment, MenuItem } from 'src/app/core/models/cart-item.model';
import {RestaurantStore} from '../../../../core/stores/restaurant.store';
import {Restaurant} from '../../../../core/models/restaurant.model';
import { Tip } from '../../../../core/enums/tip.enum';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject();
  defaultImage = './assets/images/default-image.svg';
  public tip = Tip;

  menuItemsInCart: MenuItemForPayment[];
  public restaurant: Restaurant;
  subtotalPrice = 0;

  public showTipsExpanded = false;
  public showDriverTip = false;
  constructor(
    private router: Router,
    public cartStore: CartStore,
    public restaurantStore: RestaurantStore
  ) {}

  ngOnInit() {
    this.cartStore.items$.subscribe(
      menuItems => {
        this.menuItemsInCart = menuItems;
        if (this.menuItemsInCart[0]) {
          this.getRestaurant(this.menuItemsInCart[0]);
        }
      },
      error => this.router.navigate(['/'])
    );
    if (this.cartStore.autoGratuityPercent === 0) {
      this.showTipsExpanded = true;
      this.showDriverTip = true;
    }
    if (this.restaurant.allowScheduledPickups || this.restaurant.merchantId === 'E0V9GD895GK84') {
      this.cartStore.printAheadDuration = this.restaurant.printAheadDuration;
      this.cartStore.pickupWindowDuration = this.restaurant.pickupWindowDuration;
    } else {
      this.cartStore.pickupAt = null;
      this.cartStore.printAheadDuration = null;
      this.cartStore.pickupWindowDuration = null;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  deleteItemFromCart(i: number) {
    this.cartStore.deleteItemFromCart(i);
  }

  private getRestaurant({locationId}: MenuItemForPayment) {
    this.restaurantStore
      .getRestaurantById(locationId)
      .subscribe(restaurant => {
        this.restaurant = restaurant;
      });
  }

  goPrevPage() {
    window.history.back();
  }

  getFormattedPrice(price: string | number, quantity = 1): string {
    return (+price * quantity).toFixed(2);
  }

  public getFormattedTip(tipType: Tip) {
    const result = 100 * this.cartStore.getTip(tipType) / this.cartStore.totalPrice;
    return isNaN(result) ? 0 : result;
  }

  getAvailable(): boolean {
    return !!this.cartStore.pickupAt;
  }

  changeQuantity(item, isIncrease) {
    if (isIncrease) {
      item.quantity++;
    } else if (item.quantity > 1) {
      item.quantity--;
    }
  }
}
